import React, { useRef, useState } from "react";
import FileUpload from "../../../../util/FileUpload";

const HealthBloodForm = ({ onSubmit, onCancel }) => {
    const dateOfResultRef = useRef(new Date().toISOString());
    const commentRef = useRef();
    // local state
    const [takenBy, setTakenBy] = useState(null);
    const [selectResults, setSelectedResult] = useState([]);
    const [attachment, setAttachment] = useState(null);

    const items = [
        { id: 1, name: "Thyroid Function" },
        { id: 2, name: "Bone Profiles" },
        { id: 3, name: "HBA1c" },
        { id: 4, name: "B12 and Folate" },
        { id: 5, name: "Liver Function" },
        { id: 6, name: "Lipids" },
        { id: 7, name: "CRP" },
        { id: 8, name: "Calcium" },
        { id: 9, name: "Kidney Function" },
        { id: 10, name: "Clothing Screen" },
        { id: 11, name: "CPK" },
        { id: 12, name: "Lithium" },
        { id: 13, name: "Drug Levels" },
        { id: 14, name: "Hormones" },
        { id: 15, name: "Prolactin" },
    ];
    return (
        <form
            method="POST"
            onSubmit={(e) => {
                e.preventDefault();
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                onSubmit({
                    takenBy,
                    attachment,
                    comment: commentRef.current.value,
                    dateOfResult: dateOfResultRef.current.value,
                    blood_results_group: selectResults.map((item) => item.name),
                });
            }}
        >
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Admin</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "50%", backgroundColor: "aliceblue" }}>
                                <strong> Date of Result* </strong>
                            </td>
                            <td>
                                <input type="date" className="form-control input-height" id="date-results" ref={dateOfResultRef} required aria-describedby="date-results" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%", backgroundColor: "aliceblue" }}>
                                <strong> Taken By* </strong>
                            </td>
                            <td>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" className="custom-control-input" onChange={() => setTakenBy("Internal")} name="taken" id="Internal" />
                                    <label className="custom-control-label" htmlFor="Internal">
                                        Internal
                                    </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="taken" onChange={() => setTakenBy("External")} className="custom-control-input" id="External" />
                                    <label className="custom-control-label" htmlFor="External">
                                        External
                                    </label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Blood Results Group</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td>
                                <div className="row">
                                    {items.map((item, idx) => (
                                        <div key={idx} className="col-3 box p-2">
                                            <div className="custom-control custom-checkbox">
                                                <input
                                                    onChange={() => {
                                                        const index = items.findIndex((c) => c.name === item);
                                                        if (index !== -1) {
                                                            const _list = Array.from(selectResults);
                                                            _list.push(item.name);
                                                            setSelectedResult(_list);
                                                        } else {
                                                            const _list = Array.from(selectResults);
                                                            _list.splice(index, 1);
                                                            setSelectedResult(_list);
                                                        }
                                                    }}
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    id={"item" + idx}
                                                />
                                                <label className="custom-control-label" htmlFor={"item" + idx}>
                                                    {item.name}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Additional Information</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "50%", backgroundColor: "aliceblue" }}>
                                <strong>Comments </strong>
                            </td>
                            <td>
                                <textarea name="instruction-id" id="instruction-id" ref={commentRef} className="form-control form-control-textarea" rows="4" placeholder="enter comments"></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "50%", backgroundColor: "aliceblue" }}>
                                <strong> Results Attachment* </strong>
                            </td>
                            <td>
                                <FileUpload title="" onData={(item) => setAttachment(item.path)} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="form-group text-center m-t-20">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                    Create Health Blood
                    <i className="material-icons">keyboard_arrow_down</i>
                </button>
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle">
                    Cancel <i className="material-icons text-danger">close</i>
                </button>
            </div>
        </form>
    );
};
export default HealthBloodForm;
